export function isValidFilterType(filterType: string): boolean {
  const validFilterTypes = ['combinedBooleanFilters', 'multiple', 'single', 'rating', 'input'];

  return validFilterTypes.includes(filterType);
}
